import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.textBackground.light,
    marginBottom: theme.spacing(12),
    padding: theme.spacing(0, 1),
  },
  footerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
  },
  customFooter: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
  },
}))
